import React  from 'react';
import waipinlaoshipinyonliucheng from '../assets/img/waipinlaoshipinyonliucheng.png';
import waipinjiangshishenqingbiao from '../assets/img/waipinjiangshishenqingbiao.png';
const Enclosure91 = () => 
    <div
        style={{
            WebkitTouchCallout:'none',  /*系统默认菜单被禁用*/
            MozUserSelect: 'none',  /*火狐*/
            WebkitUserSelect: 'none',  /*webkit浏览器*/
            msUserSelect: 'none',  /*IE10*/
            khtmlUserSelect: 'none',  /*早期浏览器*/
            userSelect: 'none',
        }}
     >
        <div style={{ textIndent: '2em' }}>
        <img src={waipinlaoshipinyonliucheng} alt="" style={{ width  : '90%', display: 'block', margin : '0 auto' }}/>
        <img src={waipinjiangshishenqingbiao} alt="" style={{ width  : '90%', display: 'block', margin : '0 auto' }}/>

                        
            <br/><br/>
        </div>
    </div>


export default Enclosure91;